import React from 'react'
import * as ReactBootstrap from 'react-bootstrap'
import {useSelector } from 'react-redux'
import { Field, reduxForm } from 'redux-form'
import { FormButtons, renderers, validations } from '../../../components'

export const GSXInformationFormName = 'GSXInformationForm'
let GSXInformationFormHTML = ({
  handleSubmit,
  pristine,
  reset,
  dispatch,
  submitting,
  gsx_repair_types,
  gsx_service_types
}) => {
  const { boolean_list } = useSelector((state) => state.lists)
  return (
    <form onSubmit={handleSubmit}>
      <ReactBootstrap.Row>
        <ReactBootstrap.Col xs="12">
          <div>
            <Field
              name="gsx_reference_number"
              label="GSX Reference Number"
              validate={[
                validations.required,
                validations.gsxReferenceNumber,
                validations.maxLength(10),
              ]}
              component={renderers.renderField}
              type="text"
            />
            <Field
              name="comptia_code"
              label="Comptia Code"
              validate={[validations.required]}
              component={renderers.renderField}
              type="text"
            />
             <Field
              component={renderers.renderSelectField}
              as="select"
              name="gsx_service_type"
              label="GSX Service Type"
              validate={[validations.required]}
            >
              {gsx_service_types &&
                gsx_service_types.map((sp) => (
                  <option key={sp.url} value={sp.code || sp.value}>
                    {sp.value}
                  </option>
                ))}
            </Field>


            <Field
              component={renderers.renderSelectField}
              as="select"
              name="gsx_repair_type"
              label="GSX Repair Type"
              validate={[validations.required]}
            >
              {gsx_repair_types &&
                gsx_repair_types.map((sp) => (
                  <option key={sp.url}  value={sp.code || sp.value}>
                    {sp.value}
                  </option>
                ))}
            </Field>

            {/*<Field*/}
            {/*  component={renderers.renderSelectField}*/}
            {/*  as="select"*/}
            {/*  validate={[validations.required]}*/}
            {/*  name="is_pop_uploaded"*/}
            {/*  label="Is POP Content"*/}
            {/*>*/}
            {/*  {boolean_list &&*/}
            {/*    boolean_list.map((sp) => (*/}
            {/*      <option key={sp.key} value={sp.value}>*/}
            {/*        {sp.text}*/}
            {/*      </option>*/}
            {/*    ))}*/}
            {/*</Field>*/}

            <FormButtons
              submitting={submitting}
              pristine={pristine}
              reset={reset}
            />
          </div>
        </ReactBootstrap.Col>
      </ReactBootstrap.Row>
    </form>
  )
}
export const GSXInformationForm = reduxForm({
  form: GSXInformationFormName,
})(GSXInformationFormHTML)
